import { noop } from '@gem/utils';

import { AudioSourceType } from 'APP/constants/app';
import Entities from 'STORE';
import { TPauseAudioSourceCallback } from 'STORE/App/App.types';

import { removeSource } from './removeSource';

export type TRemoveAudioSource = () => void;

export function setCurrentSource(
  type: AudioSourceType,
  callback: TPauseAudioSourceCallback = noop
): TRemoveAudioSource {
  Entities.App.currentAudioSources.forEach((source) => source.callback());
  Entities.App.addCurrentAudioSource({ type, callback });

  return (): void => removeSource(type, callback);
}
